import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, CheckCircle, Shield } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card } from '../../components/ui/card';

const DutyOfCandour = () => {
  const commitments = [
    'Inform the individual (and/or their representative) as soon as possible',
    'Offer a sincere apology',
    'Provide a clear explanation of what happened',
    'Outline actions taken to prevent recurrence'
  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#E8F4FC] to-[#F0EDF7] py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center space-y-6">
            <Heart className="w-16 h-16 text-[#4A90E2] mx-auto" />
            <h1 className="heading-hero">Duty of Candour</h1>
            <p className="body-large">
              Committed to openness, transparency, and honesty in line with the statutory Duty of Candour.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="section bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <p className="body-large text-center mb-12">
              Three Spheres Healthcare is committed to openness, transparency, and honesty in line with the statutory <strong>Duty of Candour</strong>.
            </p>

            <h2 className="heading-2 mb-8 text-center">Our Commitment</h2>
            <p className="body-medium text-gray-700 text-center mb-8">
              Where an incident occurs that results in harm or distress, we will:
            </p>

            <div className="grid md:grid-cols-2 gap-6 mb-12">
              {commitments.map((commitment, index) => (
                <Card key={index} className="p-6 border-0 bg-[#E8F4FC]">
                  <div className="flex items-start gap-4">
                    <CheckCircle className="text-[#4A90E2] flex-shrink-0 mt-1" size={24} />
                    <p className="text-gray-800">{commitment}</p>
                  </div>
                </Card>
              ))}
            </div>

            <div className="bg-gradient-to-br from-[#E8F4FC] to-[#F0EDF7] rounded-2xl p-8 md:p-12 text-center">
              <Shield className="w-12 h-12 text-[#4A90E2] mx-auto mb-6" />
              <p className="body-large text-gray-800">
                We view Duty of Candour as a fundamental part of safe, ethical, and compassionate care.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section bg-gradient-to-r from-[#4A90E2] to-[#7B68BE] text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center space-y-6">
            <h2 className="heading-2 text-white">Questions About Our Policies?</h2>
            <p className="body-large text-white/90">
              Contact us for more information about our Duty of Candour commitment.
            </p>
            <Link to="/contact">
              <Button size="lg" className="bg-white text-[#4A90E2] hover:bg-gray-100">
                Get in Touch
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DutyOfCandour;
